<div class="process-progress-container">
  <div class="process-btns-left">
    @if ((drawingState$ | async) === lDRAWINGSTATES.FINISHED || curProcessStep > 0) {
      <button
        class="btn-small btn-blue-secondary process-btn"
        style="margin-left: 24px"
        (click)="backBtnClicked()"
        >
        {{ "map.default.progressbar.back.label" | translate }}
      </button>
    }
    @if ((drawingState$ | async) !== lDRAWINGSTATES.FINISHED && curProcessStep === 0) {
      <button
        class="btn-small btn-blue-secondary process-btn"
        style="margin-left: 24px"
        (click)="cancelBtnClicked()"
        >
        {{ "map.default.progressbar.cancel.label" | translate }}
      </button>
    }
  </div>

  <div class="progress">
    <div class="process-steps">
      @for (step of processSteps; track step; let idx = $index) {
        <div class="process-step">
          <div class="lines-and-dots">
            @if (idx > 0) {
              <div
            [class]="
              curProcessStep >= idx
                ? 'step-connector-line line-active'
                : 'step-connector-line line-inactive'
            "
              ></div>
            }
            <div
            [class]="
              curProcessStep >= idx
                ? 'step-dot dot-active'
                : 'step-dot dot-inactive'
            "
            ></div>
          </div>
        </div>
      }
    </div>
    <div class="step-label-container">
      <div class="step-label">
        {{ "map.default.progressbar.steps." + (label$ | async) | translate }}
        @if (
          selField !== undefined &&
          (processMode$ | async) === lMAPMODES.FIELDEDITING
          ) {
          <span
            >&nbsp;({{ selField.name }})</span
            >
          }
        </div>
      </div>
    </div>

    <div class="process-btns-right">
      @if ((drawingState$ | async) === lDRAWINGSTATES.UNFINISHED) {
        <button
          class="btn-small btn-blue-primary"
          style="margin-right: 24px"
          (click)="nextBtnClicked()"
          [disabled]="!curStates.nextStateReady"
          >
          {{ "map.default.progressbar.next.label" | translate }}
        </button>
      }

      @if ((drawingState$ | async) === lDRAWINGSTATES.FINISHED) {
        <button
          class="btn-small btn-blue-primary"
          style="margin-right: 24px"
          (click)="saveBtnClicked()"
          [disabled]="!curStates.nextStateReady"
          >
          {{ "map.default.progressbar.save.label" | translate }}
        </button>
      }
    </div>
  </div>
